module.exports = __webpack_public_path__ + "static/media/soundOff.531917f5.png";